import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const PuertoRicoFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15765'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15765)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0H20V2.8H0V0ZM0 5.6H20V8.4H0V5.6ZM0 11.2V14H20V11.2H0Z'
					fill='#FA2222'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L9.52381 7L0 14V0Z'
					fill='#1D63F9'
				/>
				<g filter='url(#filter0_d_2332_15765)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M3.33408 7.89181L1.93459 8.88767L2.46856 7.27556L1.06966 6.27892L2.79916 6.27843L3.33408 4.66663L3.869 6.27843L5.5985 6.27892L4.19959 7.27556L4.73357 8.88767L3.33408 7.89181Z'
						fill='url(#paint0_linear_2332_15765)'
					/>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_15765'
					x='1.07031'
					y='4.66663'
					width='4.52734'
					height='5.22107'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_15765'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_15765'
						result='shape'
					/>
				</filter>
				<linearGradient
					id='paint0_linear_2332_15765'
					x1='0.953125'
					y1='4.66663'
					x2='0.953125'
					y2='9.33329'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='white' />
					<stop
						offset='1'
						stopColor='#F0F0F0'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default PuertoRicoFlagIcon;
